import { Flex, Text } from '@chakra-ui/layout'
import { Icon } from '@chakra-ui/react'
import React from 'react'
import InfoIcon from '~/assets/svgs/icon-info.svg?react'
import { useModalState } from '~/atoms/ModalState'
import { MangoButtonVariant } from '~/components/shared/componentStyles/MangoButton.style'
import { MangoButton } from '~/components/shared/MangoButton'
import { MangoModal } from '~/components/shared/MangoModal'
import { Size } from '~/types/ThemeTypes'

import { useCallInProgressModalStyle } from './componentStyles/CallInProgressModal.style'

export const CallInProgressModal = () => {
  const {
    callInProgressModal: [modalState, setModalState],
  } = useModalState()

  const handleClose = () => {
    setModalState({ open: false })
  }

  const styles = useCallInProgressModalStyle()

  return (
    <MangoModal
      isOpen={modalState.open}
      onClose={handleClose}
      closeButton={false}
      size={Size.sm}
      body={
        <Flex sx={styles.bodyContainer}>
          <Icon sx={styles.icon} as={InfoIcon} />
          <Text sx={styles.headerText}>Call in progress</Text>
          <Text sx={styles.bodyText}>
            Please end your current call before switching extensions
          </Text>
        </Flex>
      }
      footer={
        <Flex sx={styles.footerContainer}>
          <MangoButton
            variant={MangoButtonVariant.Default_100}
            onClick={handleClose}
          >
            Dismiss
          </MangoButton>
        </Flex>
      }
    />
  )
}
